import React from "react";
import "./App.css";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { ErrorBoundary } from "react-error-boundary";
import { useTranslation } from "react-i18next";
import { TFunction } from "i18next";
import { SnackbarProvider } from "notistack";
import "./i18n";
import { Grid, ThemeProvider, createTheme } from "@mui/material";
import { darkColor, lightColor } from "./pages/costant";
import errorImage from "./images/error.svg";
import useStore from "./State";
import Header from "./pages/header/Header";
import Home from "./pages/home/Home";
import Login from "./pages/login/Login";

const errorFallback = (
  t: TFunction<"translation", undefined, "translation">
) => {
  return (
    <div>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignContent: "center",
          marginTop: "10%",
        }}
      >
        <img src={errorImage} alt="error" width="30%" height="30%" />
      </div>
      <h1 style={{ textAlign: "center" }}>{t("somethingWentWrong")}</h1>
      <h3 style={{ textAlign: "center" }}>{t("refreshPage")}</h3>
    </div>
  );
};

const theme = createTheme({
  palette: {
    background: {
      default: lightColor,
      paper: "white",
    },
    primary: { main: darkColor },
    mode: "light",
    text: {
      primary: darkColor,
      secondary: darkColor,
    },
    secondary: { main: darkColor },
  },
  components: {
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: "6px",
        },
      },
    },
  },
});

declare global {
  interface Window {
    _env_: any;
    api: any;
  }
}

function App() {
  const { t } = useTranslation();
  const loggedIn = useStore((state: any) => state.loggedIn);

  return (
    <ErrorBoundary FallbackComponent={() => errorFallback(t)}>
      <ThemeProvider theme={theme}>
        <SnackbarProvider
          maxSnack={3}
          anchorOrigin={{
            vertical: "top",
            horizontal: "center",
          }}
        >
          <BrowserRouter>
            <Grid container flexDirection="column" spacing={4}>
              {loggedIn && (
                <Grid item>
                  <Header />
                </Grid>
              )}
              <Grid item>
                <Routes>
                  <Route path="/home" element={<Home />} />
                  <Route path="/*" element={<Login />} />
                </Routes>
              </Grid>
            </Grid>
          </BrowserRouter>
        </SnackbarProvider>
      </ThemeProvider>
    </ErrorBoundary>
  );
}

export default App;
